$('.header-menu-wrapper nav > ul > li > a').on('mouseenter', function(){
    $(this).parent().siblings('li').removeClass('menu-dropdown-active');
    if ($(this).siblings('.dropdown-wrapper').length > 0) {
        $(this).parent().addClass('menu-dropdown-active')
    }
});

$('.header-menu-wrapper ul li .dropdown-wrapper').on('mouseleave', function() {
    $(this).closest('li.menu-dropdown-active').removeClass('menu-dropdown-active');
});

// ---------------------------------------------------------------------------
// Collection card row alignment (.variant--holder AND .product-title)
// Two things stagger the title / price / "Get Yours" button across a row:
//   1. The .variant--holder (variant thumbnails) — taller on cards that have
//      variants than on cards that don't.
//   2. The .product-title — a title that wraps to two lines is taller than a
//      single-line one on the same row.
// Rather than a blanket min-height (which opened a gap on rows that don't need
// it and couldn't adapt to a taller slider or a three-line title), measure each
// row and reserve the row's tallest holder AND tallest title on every card in
// it. Rows where nothing wraps / has no variants collapse tight.
// ---------------------------------------------------------------------------
function halcoAlignVariantHolders() {
    $('.collection-products').each(function() {
        var $grid = $(this);
        var $holders = $grid.find('.variant--holder');
        var $titles = $grid.find('.product-title');
        if (!$holders.length && !$titles.length) return;

        // Reset so we read natural heights and natural row grouping.
        $holders.css('min-height', '');
        $titles.css('min-height', '');

        // Group cards by row — cards in the same flex line share an offsetTop.
        var rows = {};
        $grid.find('.product-collection-item').each(function() {
            var key = Math.round(this.offsetTop);
            (rows[key] = rows[key] || []).push(this);
        });

        // Equalise a given child selector's height across each row.
        function equaliseByRow(selector) {
            Object.keys(rows).forEach(function(key) {
                var cards = rows[key];
                var max = 0;
                cards.forEach(function(card) {
                    var el = card.querySelector(selector);
                    if (el) { max = Math.max(max, el.offsetHeight); }
                });
                // Only reserve space on rows that actually have the element.
                if (max > 0) {
                    cards.forEach(function(card) {
                        var el = card.querySelector(selector);
                        if (el) { el.style.minHeight = max + 'px'; }
                    });
                }
            });
        }

        // Holder first (it can push the title's row position, but not its own
        // box height), then the title.
        equaliseByRow('.variant--holder');
        equaliseByRow('.product-title');
    });
}

var halcoAlignVariantTimer;
// Run once right away as well as on load. Waiting for `load` meant the bundle
// card (no variant thumbnails) sat with its title/price/button ~43px higher than
// its neighbours until every image on the page had finished, then dropped into
// line (James's recording, US collection, 2026-09-09). By the time this script
// runs, app.js has already initialised the slick thumbnail rows and both the
// canvas and the thumbs are sized by CSS aspect-ratio, so the early measurement
// is right; the load pass stays as a correction for anything that shifts later.
halcoAlignVariantHolders();
$(window).on('load', halcoAlignVariantHolders);
$(window).on('resize', function() {
    clearTimeout(halcoAlignVariantTimer);
    halcoAlignVariantTimer = setTimeout(halcoAlignVariantHolders, 150);
});

// ---------------------------------------------------------------------------
// Keep the mobile menu closed across the back/forward cache
// If a shopper opens the mobile menu, taps a link to navigate, then hits the
// browser Back button, the previous page is restored from the bfcache exactly
// as it was left — with the menu still open (body.menu-active) and scroll
// locked. Close it on pagehide (runs before the page is frozen into bfcache, so
// the cached snapshot is already closed — no flash of the open menu on the way
// back), and again on a bfcache restore (pageshow.persisted) as a fallback.
// Both re-run the theme's own hamburger toggle so scroll unlocks via
// unlockScroll(), which restores the stashed scroll position.
// ---------------------------------------------------------------------------
function halcoCloseMobileMenu() {
    if (document.body.classList.contains('menu-active')) {
        $('.menu-hamburger').trigger('click');
    }
}
window.addEventListener('pagehide', halcoCloseMobileMenu);
window.addEventListener('pageshow', function(e) {
    if (e.persisted) halcoCloseMobileMenu();
});

// ---------------------------------------------------------------------------
// Product video band — scrollbar only when it is actually needed
// The band runs its own instance of the SS videos slider. Swiper always renders a
// scrollbar and always left-aligns the row, so a product with only two or three
// videos showed a dead scrollbar under a row hugging the left edge. Measure the
// track against the viewport and, when everything already fits, centre the slides
// and drop the scrollbar. Measured rather than counted, because how many fit
// depends on the slider_view setting and the breakpoint.
// ---------------------------------------------------------------------------
function halcoFitVideoBand() {
    var band = document.querySelector('.product-video-band');
    if (!band) return;
    var wrapper = band.querySelector('.swiper-wrapper');
    if (!wrapper) return;
    var viewport = wrapper.parentElement;
    if (!viewport) return;

    var slides = wrapper.querySelectorAll('.swiper-slide');
    if (!slides.length) return;

    var content = 0;
    Array.prototype.forEach.call(slides, function (slide) {
        var style = getComputedStyle(slide);
        content += slide.getBoundingClientRect().width +
            (parseFloat(style.marginRight) || 0) +
            (parseFloat(style.marginLeft) || 0);
    });

    // The viewport carries padding (room for the card shadow, see custom.css), which
    // clientWidth includes but slides cannot use — measure against the inner width.
    var vs = getComputedStyle(viewport);
    var inner = viewport.clientWidth -
        (parseFloat(vs.paddingLeft) || 0) - (parseFloat(vs.paddingRight) || 0);
    // 1px of tolerance: sub-pixel slide widths otherwise read as an overflow.
    band.classList.toggle('has-no-overflow', content <= inner + 1);
}

var halcoVideoBandTimer;
$(window).on('load', halcoFitVideoBand);
$(window).on('resize', function () {
    clearTimeout(halcoVideoBandTimer);
    halcoVideoBandTimer = setTimeout(halcoFitVideoBand, 150);
});
// The slider is injected after DOMContentLoaded, so re-measure once it lands.
$(function () {
    setTimeout(halcoFitVideoBand, 400);
    setTimeout(halcoFitVideoBand, 1500);
});

// ---------------------------------------------------------------------------
// PDP buy-box — HALCO-PDP Figma
// https://www.figma.com/design/I2pjm0lKF7BNfzN1s5PQGo/HALCO-PDP?node-id=1-2
//
// Lives here rather than in src/js so it ships without a Laravel Mix rebuild,
// and so none of it can regress the variant resolution in src/js/module/product.js
// (which owns the actual add-to-cart wiring). Everything below is additive: the
// <select> stays the source of truth and we only mirror clicks onto it.
// ---------------------------------------------------------------------------
(function () {
    var $form = $('.shopify-product-form');
    if (!$form.length) return;

    // --- Non-colour options render as pills; the real <select> is hidden. -----
    // Setting .val() alone does not notify product.js, so change is triggered
    // explicitly — it bubbles to the .select-options handler bound in
    // src/js/module/product.js:onVariantChange.
    $form.on('click', '.variant-pill', function () {
        var $pill = $(this);
        if ($pill.hasClass('active')) return;
        var $select = $pill.closest('.select-wrapper').find('select');
        $select.val($pill.data('option-value')).trigger('change');
    });

    // Mirror the select back onto the pills, so the pills stay correct even if
    // something else in the theme sets the select (e.g. a ?variant= deep link).
    $form.on('change', 'select', function () {
        var $select = $(this);
        var $pills = $select.closest('.select-wrapper').find('.variant-pill');
        if (!$pills.length) return;
        $pills.removeClass('active').filter(function () {
            return String($(this).data('option-value')) === String($select.val());
        }).addClass('active');
    });

    // --- "Colour: <selected name>" ------------------------------------------
    // The Figma prints the selected colour beside the label. The swatch canvas
    // already carries the colour name for the technology lookup, so reuse it.
    function halcoSyncColourLabel() {
        var name = $form.find('.variant-colors .variant-item canvas.active').data('variant-name');
        if (!name) return;
        $('[data-selected-option-value]').text(name);
        $('[data-colour-technology-name]').text(name);

    }

    // The colour technology rows are marked .active by product-technology-script.js
    // once the Google Sheet lookup resolves for the selected colour. That is async and
    // offers no callback, so watch the panel for class changes instead of guessing at
    // timing, and hide the whole disclosure when the colour has no technologies.
    function halcoSyncColourTechnology() {
        var $panel = $('[data-colour-technology-panel]');
        if (!$panel.length) return;
        var anyActive = $panel.find('.colour-technology__item.active').length > 0;
        $('.colour-technology').toggleClass('is-empty', !anyActive);
    }
    // The Lure Technology band has its own hide, handled inside
    // product-technology-script.liquid (syncTechnologyBand): it renders .is-empty
    // and is revealed only once the sheet lights at least one of its cards.

    var panelEl = document.querySelector('[data-colour-technology-panel]');
    if (panelEl && window.MutationObserver) {
        new MutationObserver(halcoSyncColourTechnology).observe(panelEl, {
            subtree: true,
            attributes: true,
            attributeFilter: ['class']
        });
    }
    $(window).on('load', halcoSyncColourTechnology);
    // --- Keep the Colours section in step with the hero swatches -------------
    // productColor.js only listens to clicks inside .product-colors--container, so
    // choosing a colour up in the buy box left the big preview further down the
    // page showing whatever was selected there. Mirror the same swap, matched on
    // the colour name both places already carry.
    function halcoSyncColoursSection() {
        var name = $form.find('.variant-colors .variant-item canvas.active').data('variant-name');
        if (!name) return;
        var $nav = $('.product-color--nav .product-color-item');
        if (!$nav.length) return;
        var $match = $nav.filter(function () {
            return String($(this).data('variant-name')) === String(name);
        });
        if (!$match.length) return;
        $nav.removeClass('active');
        $match.addClass('active');
        var id = $match.first().attr('data-id');
        $('.product-color--main .product-color-item').hide();
        $('.product-color--main .product-color-item[data-id="' + id + '"]').show();
    }

    // Collapse the colour technology disclosure the moment a colour changes, so an
    // open panel does not stay open across colours. The rows themselves are NOT
    // touched here: product-technology-script.liquid now sets a definite state
    // synchronously on every change (clearing them while the sheet is still
    // loading), and this click handler fires twice per swatch — once for the
    // canvas and again for the label's synthetic click on its radio — so clearing
    // .active here landed AFTER the lookup and blanked the panel every time.
    // Hero star rating → reviews. Judge.me's own badge click looks for its review
    // widget, which this PDP does not render (the cards carousel replaced it), so
    // the wrapper scrolls to the carousel's section the same way the quicklinks do.
    $('body').on('click keydown', '.product-hero__reviews-link', function (e) {
        if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        var $target = $('.shopify-section:has(.jdgm-cards-carousel), .jdgm-cards-carousel, .jdgm-rev-widget').filter(':visible').first();
        if (!$target.length) return;
        $('html,body').animate({ scrollTop: $target.offset().top - 80 }, 'slow');
    });

    function halcoResetColourTechnology() {
        var $wrap = $('.colour-technology');
        if (!$wrap.length) return;
        $wrap.removeClass('open');
        $wrap.find('[data-colour-technology-toggle]').attr('aria-expanded', 'false');
        $wrap.find('.colour-technology__panel').stop(true, true).hide();
        halcoSyncColourTechnology();
    }

    $form.on('click', '.variant-colors .variant-item', function () {
        halcoResetColourTechnology();
        // The theme swaps the .active class on its own click handler; run after it.
        setTimeout(halcoSyncColourLabel, 0);
        setTimeout(halcoSyncColoursSection, 0);
    });

    // --- ...and the other way round ------------------------------------------
    // Choosing a colour in the Colours section drives the hero swatch rather than
    // duplicating its work: clicking that swatch is what already updates the
    // selected variant, the "Colour:" label, the colour technology panel and the
    // Lure Technology band. No loop — the hero handler above only sets classes on
    // the Colours section, it does not click it back.
    $(document).on('click', '.product-color--nav .product-color-item', function () {
        var name = $(this).data('variant-name');
        if (!name) return;
        var $canvas = $form.find('.variant-colors .variant-item canvas').filter(function () {
            return String($(this).data('variant-name')) === String(name);
        }).first();
        if (!$canvas.length || $canvas.hasClass('active')) return;
        $canvas.trigger('click');
    });
    $(window).on('load', function () {
        halcoSyncColourLabel();
        halcoSyncColoursSection();
    });

    // --- "VIEW <COLOUR> COLOUR TECHNOLOGY" disclosure ------------------------
    $(document).on('click', '[data-colour-technology-toggle]', function () {
        var $wrap = $(this).closest('.colour-technology');
        var open = $wrap.toggleClass('open').hasClass('open');
        $(this).attr('aria-expanded', open ? 'true' : 'false');
        $wrap.find('.colour-technology__panel').slideToggle(200);
    });
})();
// --- Quicklinks arrows ------------------------------------------------------
// The bar scrolls horizontally on mobile. The arrows are real buttons beside the
// track (not overlays), so they need to drive that scroll, and they disable
// themselves at each end rather than sitting there doing nothing.
(function () {
    var scroller = document.querySelector('.product-quicklinks__scroller');
    if (!scroller) return;
    var track = scroller.querySelector('.product-quiclinks--slider');
    var prev = scroller.querySelector('.ql-arrow--prev');
    var next = scroller.querySelector('.ql-arrow--next');
    if (!track || !prev || !next) return;

    function step() {
        // Roughly two links per press, capped so a short track still moves.
        return Math.max(120, Math.round(track.clientWidth * 0.6));
    }
    function sync() {
        var max = track.scrollWidth - track.clientWidth;
        // Nothing to scroll: hide both arrows (see .is-static in custom.css).
        scroller.classList.toggle('is-static', max <= 1);
        prev.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft >= max - 1;
    }
    prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
    });
    track.addEventListener('scroll', sync);
    window.addEventListener('resize', sync);
    sync();
})();

// --- Video slider edge insets -----------------------------------------------
// The sliders sit full-bleed on mobile, but the first card needs a leading inset
// and the last card must finish inside the screen rather than under its edge.
// CSS margins on the first/last slide cannot do this: Swiper computes virtualSize
// from slide widths alone, so a leading margin shifts the strip without extending
// the scroll range and the last card ends up overhanging by exactly that amount.
// slidesOffsetBefore/After are counted in virtualSize, so they do both jobs.
(function () {
    var TARGETS = [
        { sel: '.product-video-band .swiper', inset: 20 },
        { sel: '.product-right-col [id^="ss-product-video-template"] .swiper', inset: 15 }
    ];
    function apply() {
        var mobile = window.matchMedia('(max-width: 991px)').matches;
        TARGETS.forEach(function (t) {
            document.querySelectorAll(t.sel).forEach(function (el) {
                var sw = el.swiper;
                if (!sw || !sw.params) return;
                var want = mobile ? t.inset : 0;
                if (sw.params.slidesOffsetBefore === want && sw.params.slidesOffsetAfter === want) return;
                sw.params.slidesOffsetBefore = want;
                sw.params.slidesOffsetAfter = want;
                sw.update();
            });
        });
    }
    // The app initialises Swiper on its own schedule, so poll briefly rather than
    // race it, then stop once both sliders have been seen.
    var tries = 0;
    var timer = setInterval(function () {
        apply();
        if (++tries > 40) clearInterval(timer);
    }, 250);
    window.addEventListener('load', apply);
    window.addEventListener('resize', apply);
})();

// ---------------------------------------------------------------------------
// Hero gallery: size the lure render to its own ink, not its frame.
// custom.css draws the desktop gallery canvas at 115% of its box so a padded
// single-lure render (Slidog, Laser Pro: a wide PNG with lots of transparent
// margin) fills the box the way the Figma does. A composite shot that fills its
// frame — the US "Ultimate Max Lure Bundle" — grew past the gallery column at
// that size and ran under the product title, and Paul does not want it clipped
// either. So each canvas measures where its image's pixels actually are, and
// takes the largest scale (up to the CSS 115%) at which the rotated ink still
// sits inside the gallery column. Padded renders keep 115%; full-frame ones
// come down only as far as they need to. Desktop only — the mobile banner is
// unrotated and unscaled.
// ---------------------------------------------------------------------------
(function () {
    var MAX_SCALE = 1.15;    // must match the width/height % in custom.css
    var MIN_SCALE = 0.7;
    var SHIFT_X = -20;       // background-position offsets in custom.css
    var SHIFT_Y = -35;
    var COS = Math.cos(30 * Math.PI / 180);
    var SIN = Math.sin(30 * Math.PI / 180);
    var SAMPLE = 240;        // downscale the image to this many px on its long edge

    function inkPoints(img) {
        var w = img.naturalWidth, h = img.naturalHeight;
        if (!w || !h) return null;
        var k = SAMPLE / Math.max(w, h);
        var sw = Math.max(1, Math.round(w * k)), sh = Math.max(1, Math.round(h * k));
        var cv = document.createElement('canvas');
        cv.width = sw; cv.height = sh;
        var ctx = cv.getContext('2d');
        ctx.drawImage(img, 0, 0, sw, sh);
        var d;
        try { d = ctx.getImageData(0, 0, sw, sh).data; } catch (e) { return null; }
        var pts = [];
        for (var y = 0; y < sh; y++) {
            for (var x = 0; x < sw; x++) {
                var i = (y * sw + x) * 4;
                // Transparent, or the white/near-white of a JPEG backdrop, is not ink.
                if (d[i + 3] < 20) continue;
                if (d[i] > 240 && d[i + 1] > 240 && d[i + 2] > 240) continue;
                // Store as a fraction of the image so it is independent of size.
                pts.push([(x + 0.5) / sw - 0.5, (y + 0.5) / sh - 0.5]);
            }
        }
        return pts.length ? { pts: pts, aspect: w / h } : null;
    }

    // Horizontal extent of the rotated ink, in px from the box centre, for a
    // given scale of the box width.
    function extent(ink, boxW, scale) {
        var canvas = boxW * scale;                       // canvas is square
        var imgW = ink.aspect >= 1 ? canvas : canvas * ink.aspect;
        var imgH = ink.aspect >= 1 ? canvas / ink.aspect : canvas;
        var minX = Infinity, maxX = -Infinity;
        for (var i = 0; i < ink.pts.length; i++) {
            var X = ink.pts[i][0] * imgW + SHIFT_X;
            var Y = ink.pts[i][1] * imgH + SHIFT_Y;
            var X2 = COS * X - SIN * Y;
            if (X2 < minX) minX = X2;
            if (X2 > maxX) maxX = X2;
        }
        return { left: minX, right: maxX };
    }

    function fit(canvas) {
        var ink = canvas._halcoInk;
        var banner = canvas.closest('.product-variant-banner');
        var col = canvas.closest('.product-info--sticky');
        if (!ink || !banner || !col) return;
        // The banner is display:none below 992 (d-lg-block), so it measures 0
        // there and the render is left as the CSS draws it.
        if (!window.matchMedia('(min-width: 992px)').matches) return;
        var boxW = banner.clientWidth;
        if (!boxW) return;
        var bRect = banner.getBoundingClientRect();
        var cRect = col.getBoundingClientRect();
        var centre = bRect.left + bRect.width / 2;
        var roomRight = cRect.right - centre;
        var roomLeft = centre - Math.max(cRect.left, 0);
        var scale = MAX_SCALE;
        while (scale > MIN_SCALE) {
            var e = extent(ink, boxW, scale);
            if (e.right <= roomRight && -e.left <= roomLeft) break;
            scale = Math.round((scale - 0.01) * 100) / 100;
        }
        if (scale >= MAX_SCALE) {
            canvas.style.width = canvas.style.height = canvas.style.top = canvas.style.left = '';
        } else {
            canvas.style.width = canvas.style.height = (scale * 100) + '%';
            canvas.style.top = canvas.style.left = (-(scale - 1) / 2 * 100) + '%';
        }
    }

    // custom.css keeps the active canvas invisible until this class lands, so
    // the render appears once at its fitted size instead of shrinking into place.
    function reveal(canvas) {
        canvas.classList.add('is-fitted');
    }

    function measure(canvas) {
        if (canvas._halcoInk !== undefined) { if (canvas._halcoInk) fit(canvas); return; }
        canvas._halcoInk = null;
        var m = (canvas.style.backgroundImage || '').match(/url\(["']?(.*?)["']?\)/);
        if (!m) { reveal(canvas); return; }
        var img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = function () {
            canvas._halcoInk = inkPoints(img);
            if (canvas._halcoInk) fit(canvas);
            reveal(canvas);
        };
        img.onerror = function () { reveal(canvas); };
        img.src = m[1];
    }

    function run() {
        var canvases = document.querySelectorAll('.product-variant-banner canvas.variant-image--banner');
        if (!window.matchMedia('(min-width: 992px)').matches) {
            // Nothing to fit on mobile, but never leave a canvas held invisible.
            canvases.forEach(reveal);
            return;
        }
        canvases.forEach(measure);
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(run, 150);
    });
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', run);
    } else {
        run();
    }
})();

// Halco US, 4 Nov 2026: copied from the AU theme (same code), so Choose your weapon of choice swipes on
// phones and scroll rows share the grey/navy scrollbar.
// ---------------------------------------------------------------------------
// Featured collection carousel (AU homepage "Choose your weapon of choice").
// Phones and tablets (991px and under): slick is removed and the tiles become a
// swipeable row showing three and a half tiles, with a 4px grey/navy
// scrollbar matching the product comparison table (slightly rounded ends). Added 30 Oct 2026.
// The scrollbar is shared: any scroll row with a data-dd-scrollbar attribute gets one
// (Shop by species, reviews strip). It hides itself when the row doesn't overflow.
// Wider screens: prev/next buttons wherever app.js pages it with dots (up to 1400px). app.js turns
// slick's own arrows off, so on phones the only cue that the row scrolls was the dots.
// The buttons sit either side of the dots, styled to match them, so arrows and dots
// read as one control. The carousel stops at both ends instead of wrapping, so the
// back button is hidden on the first page and the next button on the last.
// Added 29 Oct 2026.
// ---------------------------------------------------------------------------
(function () {
    var $carousels = $('.featured-collection-list--carousel.slick-initialized');
    var chevron = '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    $('<style>' +
        '.dd-carousel-arrow { display: none; position: absolute; z-index: 2; width: 36px; height: 36px; margin-top: -18px; padding: 0;' +
        ' align-items: center; justify-content: center; color: #102360; background: #fff; border: 1px solid #C3C3C3; border-radius: 50%;' +
        ' cursor: pointer; transition: background-color .15s ease, border-color .15s ease, color .15s ease, opacity .15s ease; }' +
        '.dd-carousel-arrow--prev svg { transform: rotate(180deg); }' +
        '.dd-carousel-arrow:hover { color: #fff; background: #102360; border-color: #102360; }' +
        '.dd-carousel-arrow.is-hidden { opacity: 0; pointer-events: none; }' +
        '@media (hover: none) { .dd-carousel-arrow:hover { color: #102360; background: #fff; border-color: #C3C3C3; } }' +
        '@media (max-width: 1400px) { .featured-collection-list--carousel .dd-carousel-arrow { display: flex; } }' +
        '</style>').appendTo('head');
    $('<style>' +
        '.featured-collection-list--carousel.dd-scroller { display: flex; flex-wrap: nowrap; justify-content: flex-start !important; margin: 0 calc(50% - 50vw); padding: 0 10px;' +
        ' overflow-x: auto; overscroll-behavior-x: contain; scroll-snap-type: x proximity; scroll-padding-left: 10px; scrollbar-width: none; -webkit-overflow-scrolling: touch; }' +
        '.featured-collection-list--carousel.dd-scroller::-webkit-scrollbar { display: none; }' +
        '.featured-collection-list--carousel.dd-scroller > .collection--item { flex: 0 0 calc((100vw - 10px) / 3.5); max-width: none; padding: 0 6px; scroll-snap-align: start; }' +
        '.dd-scrollbar { position: relative; height: 4px; margin: 20px 0 0; background: #DFDFDF; border-radius: 2px; touch-action: none; cursor: pointer; }' +
        '.dd-scroller + .dd-scrollbar { margin: 20px calc(50% - 50vw + 16px) 0; }' +
        '.dd-scrollbar[hidden] { display: none; }' +
        '.dd-scroll-arrow { display: none; position: absolute; z-index: 3; width: 44px; height: 44px; margin-top: -22px; padding: 0; align-items: center; justify-content: center;' +
        ' color: #102360; background: #fff; border: 0; border-radius: 50%; box-shadow: 0 2px 12px rgba(0, 0, 0, .22); cursor: pointer; transition: opacity .15s ease, background-color .15s ease, color .15s ease; }' +
        '.dd-scroll-arrow--prev svg { transform: rotate(180deg); }' +
        '.dd-scroll-arrow:hover { color: #fff; background: #102360; }' +
        '.dd-scroll-arrow.is-hidden { opacity: 0; pointer-events: none; }' +
        '@media (min-width: 992px) { .dd-scroll-arrow { display: flex; } [data-dd-scrollbar] + .dd-scrollbar { display: none; } }' +
        '.dd-scrollbar::before { content: ""; position: absolute; left: 0; right: 0; top: -10px; bottom: -10px; }' +
        '.dd-scrollbar__thumb { position: absolute; top: 0; left: 0; height: 100%; background: #102360; border-radius: 2px; }' +
        '</style>').appendTo('head');
    // Native scroll row plus a drawn scrollbar (iOS hides real ones), draggable like Swiper's.
    function makeScroller(el) {
        var bar = document.createElement('div');
        bar.className = 'dd-scrollbar';
        bar.innerHTML = '<div class="dd-scrollbar__thumb"></div>';
        el.parentNode.insertBefore(bar, el.nextSibling);
        var thumb = bar.firstChild;
        // Desktop (992px+): arrows sit on the first and last visible tiles instead of the bar,
        // 16px inside the row so they never clip. Each hides at its end of the row.
        var parent = el.parentNode;
        if (getComputedStyle(parent).position === 'static') parent.style.position = 'relative';
        var prev = document.createElement('button'), next = document.createElement('button');
        prev.type = next.type = 'button';
        prev.className = 'dd-scroll-arrow dd-scroll-arrow--prev';
        next.className = 'dd-scroll-arrow dd-scroll-arrow--next';
        prev.setAttribute('aria-label', 'Scroll back');
        next.setAttribute('aria-label', 'Scroll forward');
        prev.innerHTML = next.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        parent.appendChild(prev);
        parent.appendChild(next);
        prev.addEventListener('click', function () { el.scrollBy({ left: -el.clientWidth, behavior: 'smooth' }); });
        next.addEventListener('click', function () { el.scrollBy({ left: el.clientWidth, behavior: 'smooth' }); });
        function update() {
            var max = el.scrollWidth - el.clientWidth;
            bar.hidden = max <= 1;
            var tw = bar.clientWidth * el.clientWidth / el.scrollWidth;
            thumb.style.width = tw + 'px';
            thumb.style.transform = 'translateX(' + (max > 0 ? el.scrollLeft / max * (bar.clientWidth - tw) : 0) + 'px)';
            // Centre the arrows on the tile photos when there are any, else on the row.
            var pr = parent.getBoundingClientRect(), er = el.getBoundingClientRect();
            var img = el.querySelector('img'), mr = img ? img.parentNode.getBoundingClientRect() : er;
            prev.style.top = next.style.top = (mr.top + mr.height / 2 - pr.top) + 'px';
            prev.style.left = (er.left - pr.left + 16) + 'px';
            next.style.left = (er.right - pr.left - 16 - 44) + 'px';
            prev.classList.toggle('is-hidden', el.scrollLeft <= 1);
            next.classList.toggle('is-hidden', el.scrollLeft >= max - 1);
        }
        function scrollTo(x) {
            var tw = thumb.offsetWidth, r = bar.getBoundingClientRect();
            var p = Math.min(1, Math.max(0, (x - r.left - tw / 2) / (r.width - tw)));
            el.scrollLeft = p * (el.scrollWidth - el.clientWidth);
        }
        bar.addEventListener('pointerdown', function (e) {
            el.style.scrollSnapType = 'none';
            scrollTo(e.clientX);
            function move(ev) { scrollTo(ev.clientX); }
            function up() { el.style.scrollSnapType = ''; window.removeEventListener('pointermove', move); window.removeEventListener('pointerup', up); }
            window.addEventListener('pointermove', move);
            window.addEventListener('pointerup', up);
        });
        el.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        window.addEventListener('load', update);
        // Re-check when the row itself changes size (fonts, images, late layout).
        if (window.ResizeObserver) new ResizeObserver(update).observe(el);
        update();
    }
    window.ddScrollbar = makeScroller;
    $('[data-dd-scrollbar]').each(function () { makeScroller(this); });
    $carousels.each(function () {
        var $c = $(this);
        if (window.matchMedia('(max-width: 991px)').matches) {
            $c.slick('unslick');
            this.classList.add('dd-scroller');
            // The theme's container clips 15px in from each side; the full-width section clips instead,
            // so the row runs to the screen edges.
            this.parentNode.style.overflow = 'visible';
            makeScroller(this);
            return;
        }
        // Breakpoint changes rebuild options from originalSettings, so turn wrap-around off there too.
        $c.slick('getSlick').originalSettings.infinite = false;
        $c.slick('slickSetOption', 'infinite', false, true);
        var $prev = $('<button type="button" class="dd-carousel-arrow dd-carousel-arrow--prev" aria-label="Previous">' + chevron + '</button>');
        var $next = $('<button type="button" class="dd-carousel-arrow dd-carousel-arrow--next" aria-label="Next">' + chevron + '</button>');
        $c.append($prev, $next);
        $prev.on('click', function () { $c.slick('slickPrev'); });
        $next.on('click', function () { $c.slick('slickNext'); });
        // Line the buttons up with the dots, 16px out from the first and last dot.
        function update() {
            var dots = $c.find('.slick-dots li');
            if (!dots.length) return;
            var box = $c.get(0).getBoundingClientRect();
            var first = dots.first().get(0).getBoundingClientRect();
            var last = dots.last().get(0).getBoundingClientRect();
            var top = first.top - box.top + first.height / 2;
            $prev.css({ top: Math.round(top) + 'px', left: Math.round(first.left - box.left - 16 - 36) + 'px' });
            $next.css({ top: Math.round(top) + 'px', left: Math.round(last.right - box.left + 16) + 'px' });
            var slick = $c.slick('getSlick');
            $prev.toggleClass('is-hidden', slick.currentSlide <= 0);
            $next.toggleClass('is-hidden', slick.currentSlide >= slick.slideCount - slick.options.slidesToShow);
        }
        $c.on('setPosition afterChange breakpoint', update);
        $(window).on('load resize', update);
        update();
    });
})();

// Accessibility, 4 Nov 2026: the product quantity -/+ controls are spans; let keyboard users press them
// with Enter or Space (they carry role="button" and tabindex="0" in snippets/product-form-quantity.liquid).
document.addEventListener('keydown', function (e) {
  var t = e.target;
  if (!t || !t.classList || !t.classList.contains('btn-quantity-control')) return;
  if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); t.click(); }
});

// Accessibility, 4 Nov 2026: slick hides off-screen and cloned slides with aria-hidden but leaves their
// links focusable (e.g. the cart page product carousel). Take those links out of the tab order while hidden.
(function () {
  function sync(slide) {
    var hidden = slide.getAttribute('aria-hidden') === 'true';
    [].forEach.call(slide.querySelectorAll('a, button, input, select, textarea, [tabindex]'), function (el) {
      if (el === slide) return;
      if (hidden) { if (!el.hasAttribute('data-dd-tab')) el.setAttribute('data-dd-tab', el.getAttribute('tabindex') || ''); el.setAttribute('tabindex', '-1'); }
      else if (el.hasAttribute('data-dd-tab')) { var t = el.getAttribute('data-dd-tab'); if (t) el.setAttribute('tabindex', t); else el.removeAttribute('tabindex'); el.removeAttribute('data-dd-tab'); }
    });
  }
  function scan() { [].forEach.call(document.querySelectorAll('.slick-slide'), sync); }
  new MutationObserver(function (list) {
    var again = false;
    list.forEach(function (m) { if (m.type === 'attributes' && m.target.classList && m.target.classList.contains('slick-slide')) sync(m.target); else if (m.type === 'childList') again = true; });
    if (again) scan();
  }).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-hidden'] });
  scan();
})();

// 4 Nov 2026: iOS Safari sometimes keeps the old clip on a horizontal scroll row after its contents grow (images or the
// web font arriving late), cutting off the bottom of the cards until the first swipe. Nudge each row once its contents
// have loaded, which is what the first swipe does.
(function () {
  function nudge() {
    [].forEach.call(document.querySelectorAll('[data-dd-scrollbar], .dd-scroller, .product-slider__track'), function (el) {
      if (el.scrollWidth <= el.clientWidth) return;
      var x = el.scrollLeft; el.scrollLeft = x + 1; el.scrollLeft = x;
    });
  }
  window.addEventListener('load', nudge);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(nudge);
  [].forEach.call(document.querySelectorAll('[data-dd-scrollbar] img, .dd-scroller img, .product-slider__track img'), function (img) {
    if (!img.complete) img.addEventListener('load', nudge, { once: true });
  });
})();
